import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "./context/AuthContext";
import api from "./services/api";

export default function PaymentSuccessPage() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [customerEmail, setCustomerEmail] = useState<string | null>(null);
  const [userCredits, setUserCredits] = useState<number | null>(null);
  const location = useLocation();
  const navigate = useNavigate();
  const { refreshUserData } = useAuth();

  useEffect(() => {
    const checkPaymentStatus = async () => {
      try {
        const queryParams = new URLSearchParams(location.search);
        const sessionId = queryParams.get("session_id");
        const plan = queryParams.get("plan");

        if (!sessionId) {
          setError("Missing session information. Please contact support.");
          return;
        }

        // Instead of making an API call, use the plan parameter from URL
        if (plan) {
          // Map plan to credits based on the backend PLANS object
          const planCreditsMap: Record<string, number> = {
            basic: 10,
            pro: 20,
            enterprise: 80,
          };

          setCustomerEmail("your email"); // Hardcoded placeholder
          setUserCredits(planCreditsMap[plan] || 20); // Default to 20 if plan not found

          // Refresh user data once to update UI
          // await refreshUserData();
        } else {
          setError("Plan information missing. Please contact support.");
        }
      } catch (error) {
        console.error("Error processing payment information:", error);
        setError(
          "An error occurred while processing your payment information. Please contact support."
        );
      }
    };

    checkPaymentStatus();
  }, [location, refreshUserData]);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen p-4">
        <div className="bg-red-50 p-6 rounded-lg max-w-lg w-full text-center">
          <h2 className="text-xl font-semibold text-red-700 mb-3">
            Payment Verification Failed
          </h2>
          <p className="text-red-600 mb-4">{error}</p>
          <button
            onClick={() => navigate("/dashboard")}
            className="px-6 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition"
          >
            Go to Dashboard
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col justify-center items-center min-h-[70vh] bg-white p-4">
      <div className="border border-blue-500 p-8 rounded-lg max-w-lg w-full shadow-md">
        <div className="flex justify-center mb-4">
          <div className="bg-blue-100 rounded-full p-3">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-10 w-10 text-blue-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
        </div>

        <h1 className="text-2xl font-bold text-gray-800 text-center mb-4">
          Payment Successful!
        </h1>

        <p className="text-gray-700 mb-6 text-center">
          You are now on the Free Trial, and will be charged in 7 days.
        </p>

        <div className="flex justify-center">
          <button
            onClick={() => navigate("/dashboard")}
            className="px-6 py-3 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors hover:cursor-pointer"
          >
            Go to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
}
